import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Linkedin, Globe, ArrowRight } from 'lucide-react';
import AIIcon from './AIIcon';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const services = [
    { name: 'GEO – Generative Engine Optimization', path: '/services/geo' },
    { name: 'AEO – Answer Engine Optimization', path: '/services/aeo' },
    { name: 'AIO – AI Optimization', path: '/services/aio' },
    { name: 'CAO – Conversational AI Optimization', path: '/services/cao' },
    { name: 'LLMO – LLM Optimization', path: '/services/llmo' },
    { name: 'GAIO – Generative AI Optimization', path: '/services/gaio' },
    { name: 'AISO – AI Search Optimization', path: '/services/aiso' },
    { name: 'SRO – Search Response Optimization', path: '/services/sro' },
  ];

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <Link to="/" className="footer-logo">
                <span className="logo-icon"><AIIcon size={24} /></span>
                <div className="logo-text-group">
                  <span className="logo-text">Rajesh <span className="gradient-text">R</span></span>
                  <span className="logo-sub">AI Technology Specialist</span>
                </div>
              </Link>
              <p className="footer-desc">
                Kerala's #1 AI Platform & Answer Engine Optimization expert. Helping businesses get found in ChatGPT, Gemini, Perplexity & next-gen AI search.
              </p>
              <div className="footer-contact-list">
                <a href="tel:+917907038984" className="footer-contact-item">
                  <Phone size={14} />
                  <span>+91 79070 38984</span>
                </a>
                <a href="mailto:info@rajeshrnair.com" className="footer-contact-item">
                  <Mail size={14} />
                  <span>info@rajeshrnair.com</span>
                </a>
                <div className="footer-contact-item">
                  <MapPin size={14} />
                  <span>Trivandrum, Kerala, India</span>
                </div>
              </div>
              <div className="footer-social">
                <a href="https://rajeshrnair.com" target="_blank" rel="noreferrer" className="social-icon" title="Website">
                  <Globe size={16} />
                </a>
                <a href="https://www.linkedin.com/in/rajesh8129355259/" target="_blank" rel="noreferrer" className="social-icon" title="LinkedIn">
                  <Linkedin size={16} />
                </a>
                <a href="https://wa.me/917907038984?text=Hi%20Rajesh!%20I%20saw%20your%20website%20footer%20and%20would%20like%20to%20discuss%20AI%20optimization%20for%20my%20business." target="_blank" rel="noreferrer" className="social-icon" title="WhatsApp">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                </a>
              </div>
            </div>

            <div className="footer-col">
              <h4 className="footer-heading">Our Services</h4>
              <ul className="footer-links">
                {services.map(s => (
                  <li key={s.name}>
                    <Link to={s.path} className="footer-link">
                      <ArrowRight size={12} />
                      {s.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-col">
              <h4 className="footer-heading">Quick Links</h4>
              <ul className="footer-links">
                <li><Link to="/" className="footer-link"><ArrowRight size={12} />Home</Link></li>
                <li><Link to="/about" className="footer-link"><ArrowRight size={12} />About Rajesh</Link></li>
                <li><Link to="/services" className="footer-link"><ArrowRight size={12} />All Services</Link></li>
                <li><Link to="/kerala-analysis" className="footer-link"><ArrowRight size={12} />Kerala Market Analysis</Link></li>
                <li><Link to="/contact" className="footer-link"><ArrowRight size={12} />Contact</Link></li>
                <li><a href="/sitemap.xml" className="footer-link"><ArrowRight size={12} />Sitemap</a></li>
                <li>
                  <Link to="/site-audit" className="footer-link footer-link-highlight">
                    <ArrowRight size={12} />Free Site Audit Tool
                  </Link>
                </li>
              </ul>

              <div className="footer-legal-links">
                <Link to="/terms-and-conditions" className="footer-legal-link">Terms & Conditions</Link>
                <span className="footer-legal-sep">·</span>
                <Link to="/privacy-policy" className="footer-legal-link">Privacy Policy</Link>
              </div>

              <h4 className="footer-heading" style={{marginTop:'28px'}}>Platforms We Optimize</h4>
              <div className="platform-tags">
                {['ChatGPT','Gemini','Perplexity','Claude','Copilot','Grok','You.com','Bing AI'].map(p => (
                  <span key={p} className="platform-tag">{p}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p className="footer-copy">
            © {currentYear} Rajesh R | AI Platform Optimization Expert, Trivandrum, Kerala. All rights reserved.
          </p>
          <p className="footer-schema-note">
            <span className="live-dot" style={{display:'inline-block',width:'6px',height:'6px',background:'var(--accent-green)',borderRadius:'50%',marginRight:'6px'}}></span>
            Optimized for ChatGPT · Gemini · Perplexity · Claude · Copilot
          </p>
        </div>
        <div className="container footer-legal-bar">
          <Link to="/terms-and-conditions" className="footer-legal-bar-link">Terms & Conditions</Link>
          <span style={{color:'rgba(255,255,255,0.2)'}}>·</span>
          <Link to="/privacy-policy" className="footer-legal-bar-link">Privacy Policy</Link>
          <span style={{color:'rgba(255,255,255,0.2)'}}>·</span>
          <span style={{color:'rgba(255,255,255,0.25)',fontSize:'0.72rem'}}>Free audit results are AI-generated and for informational purposes only.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
